import Illusion from 'illusionjs'
import Model from './Model'
import { ModelType, PickEntityInstance, PickCustomMethods } from './types'

const Eloquent = <R extends typeof Model, D extends new () => any>(model: R, entity: D): ModelType<PickEntityInstance<D>, PickCustomMethods<R>> => {
        
    return Illusion<ModelType<PickEntityInstance<D>, PickCustomMethods<R>>>(model)
} 

export default Eloquent